export default __webpack_public_path__ + "static/media/car3.2a85df43.jpg";